import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-boldest text-gray-800 fs-2" }, "สินค้าขายดี"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 fw-bold mt-2 fs-6" }, "รายการสินค้าขายดีประจาเดือน")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"my-1 pe-6\"><label for=\"\">Category</label><select class=\"form-select form-select-sm form-select-solid fw-bolder w-125px\" data-control=\"select2\" data-placeholder=\"All Users\" data-hide-search=\"true\"><option value=\"1\" selected>Show All</option><option value=\"2\">Active users</option><option value=\"3\">Pending users</option></select></div><div class=\"my-1 pe-6\"><label for=\"\">Status</label><select class=\"form-select form-select-sm form-select-solid fw-bolder w-125px\" data-control=\"select2\" data-placeholder=\"All Users\" data-hide-search=\"true\"><option value=\"1\" selected>Show All</option><option value=\"2\">Active users</option><option value=\"3\">Pending users</option></select></div>", 2)
const _hoisted_6 = { class: "position-relative pe-6 my-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "" }, null, -1)
const _hoisted_8 = {
  class: "svg-icon svg-icon-3 svg-icon-gray-500 position-absolute translate-middle ms-6",
  style: {"margin-top":"37px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  placeholder: "Search",
  class: "w-150px form-control form-control-sm form-control-solid ps-10"
}, null, -1)
const _hoisted_10 = { class: "card-body py-0" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = {
  class: "table align-middle table-row-bordered table-row-dashed gy-5",
  id: "kt_table_widget_1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-gray-600 fw-boldest fs-5 text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "รหัสสินค้า"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "ชื่อสินค้า"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "ราคาขาย"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "จำนวนขาย"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "รวมยอดขาย"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-end" }),
  /*#__PURE__*/_createElementVNode("th", { class: "text-end" })
], -1)
const _hoisted_14 = { class: "fw-boldest" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "pe-0 text-end" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn btn-light text-muted fw-boldest btn-sm" }, "+")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _hoisted_9
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", _hoisted_12, [
          _createElementVNode("tbody", null, [
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.code), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(item.name), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(item.code), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(item.code), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(item.code), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    style: {"padding":"5px","width":"50px","cursor":"default"},
                    class: _normalizeClass(
                      i + 1 > 5
                        ? _ctx.class3
                        : i + 1 <= 3
                        ? _ctx.class1
                        : i + 1 > 3
                        ? _ctx.class2
                        : ''
                    )
                  }, " #" + _toDisplayString(i + 1), 3)
                ]),
                _hoisted_18
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}